import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { getNodeIdExistsSelector, getNodeTypeIdSelector } from "@skilitics/nautilus-core-designer-data";

import {
  getDeepestSelectionTargetCreate,
  getIsSelectionTargetSelector,
  getNodeAncestorIdsCreate,
  getNodeSlotIdSelector,
} from "../state/index.ts";

const getDeepestSelectionTargetSelector = createSelector(
  [getIsSelectionTargetSelector, getNodeTypeIdSelector, getNodeSlotIdSelector, getNodeIdExistsSelector],
  (getIsSelectionTarget, getTypeId, getSlotId, getNodeIdExists) =>
    getDeepestSelectionTargetCreate({
      getAncestorIds: getNodeAncestorIdsCreate({ getSlotId }),
      getTypeId,
      getNodeIdExists,
      getIsSelectionTarget,
    }),
);

export const useGetDeepestSelectionTarget = () => useSelector(getDeepestSelectionTargetSelector);
